import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountEmbeddableSearchEdit implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountEmbeddableSearchEditContainer";
    }


    render() {
        let self=this;
        this.zidx.zidxBase.resetForNavigation();
        this.zidx.zidxBase.init(false, true, false, false);
        $("#embedSearchSave", self.zidx.peakidxShadowRoot).on("click", (e: JQuery.ClickEvent) => {
            e.preventDefault();
            let saveButton = $("#embedSearchSave", self.zidx.peakidxShadowRoot);
            if (saveButton.prop("disabled")) {
                return;
            }
            self.zidx.zidxBase.checkForSearchFormChanges(false, true);
            let data = {
                "saved_search_embed_json_criteria": self.zidx.zidxBase.json,
                "saved_search_embed_name": String($("input[name=\"search_embed_name\"]", self.zidx.peakidxShadowRoot).val() ?? "").trim(),
                "saved_search_embed_id": $("input[name=\"search_embed_id\"]", self.zidx.peakidxShadowRoot).val()
            };
            if(data.saved_search_embed_name === ""){
                alert("Please enter a name for the search");
                return;
            }

            let obj = {
                id: "ajaxSaveSearchEmbed",
                method: "post",
                postObj: data,
                ignoreOldRequests: false,
                callback: function (r1: string) {
                    let r;
                    try {
                        r = JSON.parse(r1);
                    } catch (err) {
                        saveButton.prop("disabled", false);
                        alert("Failed to save the search. Please try again.");
                        return;
                    }
                    if (r.success) {
                        self.zidx.redirectFormResponse(r, "")
                    } else {
                        saveButton.prop("disabled", false);
                        alert(r.errorMessage);
                    }
                },
                errorCallback: function () {
                    saveButton.prop("disabled", false);
                    alert("Failed to save the search. Please try again.");
                },
                url: this.zidx.getPrefixURL("/account/embeddable-searches/save")
            };
            saveButton.prop("disabled", true);
            this.zidx.ajaxRequest(obj);
        });


    }


}